const m13Section = {
  id: 'm13',
  name: '2027ScoresheetM13Sub1Label',
  fields: [
    {
      scoring: "2027ScoresheetM13Sub2Label",
      id: 'm13_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
  ]
}

export default m13Section;

